import { pick } from 'ch4o';
import { createRouter, createWebHistory } from 'vue-router';
import routes from './router.idx';

const dataCockpitRoute = {
    path: '/idx/data-cockpit',
    name: 'dataCockpit',
    title: '数据驾驶舱',
    component: () => import('@/views/data-cockpit/index.vue'),
    meta: {
        fullScreen: true,
        moduleKey: 'dashboard:admin',
    },
};

const appRoutes = routes.some(route => route.name === dataCockpitRoute.name)
    ? routes
    : routes.concat(dataCockpitRoute);

// console.log(routes)
const router = createRouter({
    history: createWebHistory(),
    routes: appRoutes,
});
/**
 * 获取当前可用的路由
 * @returns [Object Array] 当前可用的路由
 */
function getRoutes() {
    return appRoutes;
}

/**
 * 获取路由中所有带有modulekey属性的应用主页路由数据
 * 主要用于：来自中台的导航数据与该数据进行匹配，组成一个可用的路由导航数据
 */
function getStaticRoutes() {
    const res = appRoutes.reduce((staticRoutes, route) => {
        const mkey = route?.meta?.moduleKey;
        if (mkey) {
            staticRoutes[mkey] = pick(['name', 'path', 'title', 'meta'], route);
        }
        return staticRoutes;
    }, {});
    return res;
}

const staticRoutes = getStaticRoutes();

export { router as default, getRoutes, staticRoutes };
